import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { servicedeskConnectProjectRoute } from '@atlassian/jira-router-routes-connect-routes/src/servicedeskConnectProjectRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { getProjectConnectRouteDefaultResources } from './common/index.tsx';
import { connectProjectsWithoutHorizontalNavPageEntrypoint } from './ui/spa/connect/projects/index.tsx';

export const servicedeskConnectProjectRouteEntry = createEntry(
	servicedeskConnectProjectRoute,
	() => ({
		group: 'servicedesk',
		layout: serviceProjectLayout,
		navigation: {
			menuId: MENU_ID.PROJECTS,
		},
		resources: [
			...getProjectConnectRouteDefaultResources(),
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
		],
		ufoName: 'jira-connect',
		entryPoint: () => connectProjectsWithoutHorizontalNavPageEntrypoint,
	}),
);
